<template>
    <div class="vertical-line"></div>
</template>

<style lang="scss" scoped>
    .vertical-line {
        width: 1px;
        background: #ebebeb;
    }
</style>